<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export default {
  name: "DUServiceTemplateModal",
  components: {
    MaskedInput,
  },
  props: {
    modalTitle: String,
  },
  data(){
    return {
        form: {
          id: 0,
          templateName: null,
          templateDescription: null,
          minimumUnit: '',
          minimumAmount: '',
          dueInDays: '',
        },
        submitted: false,
        currencyMask: createNumberMask({
          prefix: "",
          allowDecimal: false,
        }),
    }
  },
  validations: {
    form: {
      templateName: { required },
    },
  },
  methods: {
    resetForm(){
      this.form = {
        id: 0,
        templateName: null,
        templateDescription: null,
        minimumUnit: '',
        minimumAmount: '',
        dueInDays: '',
      };
      this.submitted = false;
      this.$v.form.$reset();
    },
    updateData(data){
      this.form = cloneDeep(data)
    },
    submitForm(){
      this.submitted = true;
      this.$v.form.$touch();
      if(this.$v.form.$invalid) return;
      let data = cloneDeep(this.form);
      data.minimumUnit = data.minimumUnit ? this.getExactAmt(data.minimumUnit) : 0;
      data.minimumAmount = data.minimumAmount ? this.getExactAmt(data.minimumAmount) : 0;
      data.dueInDays = data.dueInDays ? this.getExactAmt(data.dueInDays) : 0;
      this.$emit('submit', data);
    },
  }
};
</script>
<template>
  <b-modal
    id="du-service-template-modal"
    :title="modalTitle"
    size="md"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <form  @submit.prevent="submitForm">
        <div class="mb-3">
            <label for="templateName">Template Name</label>
            <input 
                autocomplete="off"
                id="templateName"
                type="text" 
                class="form-control" 
                v-model="form.templateName" 
                :class="{'is-invalid': submitted && $v.form.templateName.$error}"

            />
            <div 
                v-if="submitted && $v.form.templateName.$error"
                class="invalid-feedback"
            >
                <span v-if="!$v.form.templateName.required">Template name is required.</span>
            </div>
        </div>
        <div class="mb-3">
            <label for="templateDescription">Description</label>
            <input 
                autocomplete="off"
                id="templateDescription"
                type="text" 
                class="form-control" 
                v-model="form.templateDescription" 

            />
        </div>
        <div class="d-flex mb-3 gap-2">
            <div class="w-50">
                <label for="unitCost">Minimum Unit</label>
                <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="form.minimumUnit"
                    placeholder="1"
                    class="form-control me-1 text-center"
                    :mask="currencyMask"
                >
                </masked-input>
            </div>
            <!-- <div class="w-50">
                <label for="minimumAmount">Minimum Amount</label>
                <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="form.minimumAmount"
                    placeholder="1"
                    class="form-control me-1 text-center"
                    :mask="currencyMask"
                >
                </masked-input>
            </div> -->
            <div class="w-50">
              <label for="minimumAmount">Due in Days</label>
              <masked-input
                  autocomplete="off"
                  type="text"
                  v-model="form.dueInDays"
                  placeholder="1"
                  class="form-control me-1 text-center"
                  :mask="currencyMask"
              >
              </masked-input>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-primary"><i class="bx bx-save"></i>{{ form.id != 0 ? "Update" : "Save" }}</button>
            <button type="button" class="btn btn-link" @click="$bvModal.hide('du-service-template-modal')">Close</button>
        </div>
    </form>
  </b-modal>
</template>